import React from 'react';
import AccountingVouchers from '../components/Vouchers/AccountingVouchers';

const VouchersPage = () => <AccountingVouchers />;

export default VouchersPage;
